export const NORMAL_CUSTOMER_TYPE_VALUE = '5'

export const JURISTIC_CUSTOMER_TYPE_VALUE = '2'

export const HEADQUARTER_BRANCH_NUMBER = '00000'

export const PaymentType = Object.freeze({
  Slip: 'slip',
  CreditCard: 'creditCard',
  QR: 'qr',
  Attachment: 'attachment'
})

export const TaxAgentStatus = Object.freeze({
  Pending: 'pending',
  Approved: 'approved',
  Rejected: 'rejected'
})
